export default __webpack_public_path__ + "static/media/date_blue.79a67eef.svg";